import React, { useCallback, useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import UserLayout from '../../layouts/UserLayout'
import { api } from '../../utils/api'
import { apiBase } from '../../services/apiBase'
import { Box, Typography, IconButton, Paper, Divider } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export default function CustomerHistoryPoints() {
	const { id } = useParams()
	const navigate = useNavigate()
	const [historyPoints, setHistoryPoints] = useState([])

	const fetchCustomerDetails = useCallback(async () => {
		try {
			const referralAcc = await apiBase.get(`${api.GET_CUSTOMER_HISTORY_POINTS}?userid=${id}`)
			setHistoryPoints(referralAcc.data || [])
		} catch (error) {
			console.error('Error fetching customer details:', error)
		}
	}, [id])

	useEffect(() => {
		fetchCustomerDetails()
	}, [fetchCustomerDetails])

	return (
		<UserLayout>
			<Box sx={styles.headerContainer}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackIcon />
				</IconButton>
				<Typography variant='h6' sx={styles.headerTitle}>
					Lịch sử tích điểm
				</Typography>
			</Box>
			<Box sx={styles.mainContainer}>
				{/* History List */}
				<Box sx={styles.historyListContainer}>
					{historyPoints.map((history) => (
						<Paper key={history._id} elevation={1} sx={styles.historyCard}>
							<Box sx={styles.historyContent} key={history._id}>
								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Mã đơn hàng:
									</Typography>
									<Typography>{history?.idOrder?.order?.id?.split('_')?.[1] ?? ''}</Typography>
								</Box>

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Khách hàng:
									</Typography>
									<Typography>
										{history?.idOrder?.order?.customer_name} - {history?.idOrder?.order?.customer_phone}
									</Typography>
								</Box>

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Cửa hàng:
									</Typography>
									<Typography>{history?.idOrder?.order?.cua_hang?.[0]?.name}</Typography>
								</Box>

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Ngày giao hàng:
									</Typography>
									<Typography>
										{history?.idOrder?.order?.shippingDate?.date} {history?.idOrder?.order?.shippingDate?.hour}:
										{history?.idOrder?.order?.shippingDate?.minute}
									</Typography>
								</Box>

								<Divider sx={styles.divider} />

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Tiền hàng:
									</Typography>
									<Typography>{history?.idOrder?.order?.total_item?.toLocaleString()}đ</Typography>
								</Box>

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Phí vận chuyển:
									</Typography>
									<Typography>{history?.idOrder?.order?.shipping_total?.toLocaleString()}đ</Typography>
								</Box>

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Tổng cộng:
									</Typography>
									<Typography fontWeight='bold'>{history?.idOrder?.order?.total?.toLocaleString()}đ</Typography>
								</Box>

								<Box sx={styles.rowBetween}>
									<Typography variant='subtitle2' color='text.secondary'>
										Điểm tích lũy:
									</Typography>
									<Typography color={history?.idOrder?.order?.useScore ? 'red' : 'green'} fontWeight='bold'>
										{history.value.toLocaleString()} điểm
									</Typography>
								</Box>

								<Divider sx={styles.divider} />

								<Typography variant='subtitle2' color='text.secondary'>
									Chi tiết đơn hàng:
								</Typography>
								<Box sx={styles.orderDetails}>
									<Typography>
										{history.idOrder.order.line_items
											.map((item, index) => `${item.name} x ${item.quantity}`)
											.join(', ')}
									</Typography>
								</Box>
							</Box>
						</Paper>
					))}
				</Box>
			</Box>
		</UserLayout>
	)
}

const styles = {
	headerContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 2,
		p: 1,
		background: '#fff',
		borderBottom: '1px solid #e0e0e0',
		position: 'sticky',
		top: 0,
		zIndex: 1000,
	},
	headerTitle: {
		ml: 1,
	},
	mainContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minHeight: '100%',
		minWidth: '100%',
		alignItems: 'center',
	},
	historyListContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		overflowY: 'auto',
		p: 2,
		maxWidth: '500px',
	},
	historyCard: {
		mb: 2,
		p: 2,
		borderRadius: 3,
	},
	historyContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
	},
	rowBetween: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	divider: {
		my: 1,
	},
	orderDetails: {
		ml: 2,
	},
}

